import React from 'react'

export default props => (
	<div className='card' style={{ ...props.style }}>
		{props.children}
	</div>
)
